/**
 * store post
 */

import { MobileState } from "../type";

export default {
    namespaced: true,
    state: (): MobileState => ({
        isShowBanner: true,
    }),
    mutations: {
        setShowBanner(state: MobileState, value: boolean): void {
            state.isShowBanner = value;
        },
    },
    actions: {
        setBannerStatus({ commit }: any, value: boolean): void {
            commit("setShowBanner", value);
        },
    },
    getters: {
        getBannerStatus(state: MobileState) {
            return state.isShowBanner;
        },
    },
};
